<template>
  <div v-if="!state.loading">
    <div class="pgehd">
        <h2>Academic Year</h2>
    </div>
    
    <PrimeDataTable
        :value="list"
        :rows="10"
        responsiveLayout="scroll"
        stripedRows>

        <PrimeColumn field="sn" header="sn" />
        <PrimeColumn field="name" header="Name" />
        <PrimeColumn field="start" header="Start Date" />
        <PrimeColumn field="end" header="End Date" />
        <PrimeColumn field="status" header="Status" />
        <PrimeColumn header="Options">
            <template #body="slotProps">
                <div class="flex gap-2">
                <PrimeButton
                    label="Results"
                    icon="pi-file-o"
                    class="p-button-rounded p-button-text"
                    @click="viewResults(slotProps.data)"
                />
                </div>
            </template>
        </PrimeColumn>
    </PrimeDataTable>
  </div>
  <div v-else class="loader">
    <img src="@/assets/img/ajldr.gif" />
  </div>
</template>
<script>
import call from "../composables/call.js";
import { urls } from "../assets/js/urls.js";
import { onMounted, reactive, ref} from 'vue';
import { useRouter } from "vue-router";

export default {
    name:"AcademicYear",
    setup(){
        const router = useRouter();
        const state=reactive({loading:true})
        const list = ref([])
        const globalFilter=ref("")
        onMounted(() => {
            call({
                url:urls.academic,
                data:{getAcademicYear:""},
                success:(res)=>{
                state.loading=false
                if(res.status){
                    if (!Array.isArray(res.msg)) {
                        list.value = Object.values(res.msg)
                    } else {
                        list.value = res.msg
                    }
                }else{
                    alert(res.msg);
                }
                }
            })
        });

        function viewResults(row){
            console.log('Edit', row)
            router.push({ name: 'academicresult', params: { id: row.id } });
        }
        
        return {list,globalFilter, state,viewResults}
    }
}
</script>